import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewChild, inject } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, ModalComponent, ModalFooterDirective, ToastService } from 'mbs-ui-kit';
import { Observable, finalize, take } from 'rxjs';

const CODE_OF_CONDUCT_URL = 'https://www.msp360.com/resources/blog/code-of-conduct/';
const TRUST_SAFETY_URL = 'https://www.msp360.com/trust-center/';

@Component({
  selector: 'mbs-access-review-required-modal',
  templateUrl: './access-review-required-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, CommonModule, I18NextPipe, ModalComponent, ModalFooterDirective]
})
export class AccessReviewRequiredModalComponent {
  private toastService = inject(ToastService);
  private i18n = inject(I18NextPipe);

  public loading = false;
  public readonly codeOfConductUrl = CODE_OF_CONDUCT_URL;
  public readonly trustSafetyUrl = TRUST_SAFETY_URL;

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  get email(): string {
    return this.baseModal.data?.email ?? '';
  }

  requestAccess(): void {
    this.loading = true;

    const request = this.baseModal.data.request as Observable<unknown>;

    request
      .pipe(
        take(1),
        finalize(() => (this.loading = false))
      )
      .subscribe({
        next: () => {
          this.toastService.success(this.i18n.transform('shared:accessReview.sendSuccess', { email: this.email }));
          this.baseModal.save();
        },
        error: (err) => {
          const reason = err?.error?.message || err?.error?.title || err?.message || '';
          this.toastService.error(this.i18n.transform('shared:accessReview.sendError', { email: this.email, reason }));
        }
      });
  }
}
